import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Admin/Integration/BusyIntegration/BusySetup';

const BusySetup = () => ((orgContainer(InnerComponent)));
export default BusySetup;
